<div class="col-xs-12 sp-0">
    <ng-content></ng-content>
</div>
